import uFuzzy from "@leeoniya/ufuzzy";

export function searchListOfObjects<T>(
  input: T[],
  hasystackFn: (x: T) => string,
  needle: string
): T[] {
  const haystack = input.map(hasystackFn);

  const uf = new uFuzzy({
    intraMode: uFuzzy.IntraMode.SingleError,
    intraIns: 1,
    intraSub: 1,
    intraTrn: 1,
    intraDel: 1,
    intraChars: "[a-zd']"
  });

  const result = uf.search(haystack, needle);

  return result[0] ? result[0]!.map((index) => input[index]) : [];
}
